/* eslint-disable complexity */
import React from 'react';
import { IS_WEBVIEW } from 'reactApp/appHelpers/configHelpers';
import { abHeavyFileBuy, abHeavyFileBuyV3 } from 'reactApp/appHelpers/featuresHelpers/features/heavyFileBuy';
import { isPurchaseDisabled } from 'reactApp/appHelpers/featuresHelpers/features/superAppAuthorizationInfo';
import { uploadBigFileModalAb } from 'reactApp/appHelpers/featuresHelpers/features/uploadBigFileModal';
import { uploadBigFileNewText } from 'reactApp/appHelpers/featuresHelpers/features/uploadBigFileNewText';
import { getQueryParams } from 'reactApp/appHelpers/settingsHelpers';
import styles from 'reactApp/components/UploadBigFileDialog/UploadBigFileDialog.css';
import { type IBigFileModalContent, EShowTariffType } from 'reactApp/components/UploadBigFileDialog/UploadBigFileDialog.types';
import { EnvironmentSelectors } from 'reactApp/modules/environment/environment';
import { Button, ButtonSizeMode } from 'reactApp/ui/Button/Button';
import { formatPrice } from 'reactApp/utils/priceHelpers';
import { EQueryParams } from 'server/helpers/getRequestParams';

interface ButtonConfig {
    text: string;
    onClick: () => void;
}

export const useButtons = ({ tariffInfo, numberOfFiles, files, callbacks, stage }: IBigFileModalContent): JSX.Element => {
    const { showTariffType, usualProduct, transactProduct } = tariffInfo;
    const isPhone = EnvironmentSelectors.isPhone();

    const fromDeeplink = getQueryParams()[EQueryParams.fromDeeplink];
    const isSuperAppWebView = IS_WEBVIEW && fromDeeplink;
    const isDisabledPurchase = isSuperAppWebView && isPurchaseDisabled();

    let buttonPrimary: ButtonConfig | null = {
        text: 'Посмотреть тарифы',
        onClick: callbacks.onRequestPayment,
    };
    let buttonSecondary: ButtonConfig | null = {
        text: 'Отменить загрузку',
        onClick: callbacks.onSkip,
    };

    if (numberOfFiles > 1) {
        buttonSecondary.text = files ? 'Пропустить файлы' : 'Пропустить файл';
    }

    if (showTariffType === EShowTariffType.TRIAL) {
        buttonPrimary.text = 'Попробовать за 1 ₽';
    }

    switch (true) {
        /* tempexp_18955-start */
        case Boolean(abHeavyFileBuyV3 && stage === 'usual'):
            buttonPrimary = {
                text: `Загрузить с подпиской`,
                onClick: callbacks.onRequestPayment,
            };
            buttonSecondary = null;
            break;
        case Boolean(abHeavyFileBuyV3 && stage === 'transact'):
            buttonPrimary = {
                text: `Загрузить за ${formatPrice(transactProduct?.price || 0)} ₽`,
                onClick: callbacks.onRequestHeavyFile,
            };
            buttonSecondary = null;
            break;
        /* tempexp_18955-end */

        /* tempexp_18869-start */
        case Boolean(abHeavyFileBuy):
            buttonPrimary = {
                text: `Загрузить за ${formatPrice(transactProduct?.price || 0)} ₽`,
                onClick: callbacks.onRequestHeavyFile,
            };
            buttonSecondary = {
                text: `Оформить подписку за ${formatPrice(usualProduct?.price || 0)} ₽`,
                onClick: callbacks.onRequestPayment,
            };
            break;
        /* tempexp_18869-end */

        case Boolean(uploadBigFileModalAb === 'b' && showTariffType === EShowTariffType.USUAL_TARIFF && usualProduct):
            buttonPrimary.text = `Подключить ${usualProduct?.space?.value}`;
            break;
        /* tempexp_18603-start */
        case uploadBigFileNewText:
            buttonSecondary.text = 'Не загружать';
            break;
        /* tempexp_18603-end */
    }

    if (isDisabledPurchase) {
        buttonPrimary = null;
    }

    return (
        <div className={styles.buttonWrapper}>
            {buttonPrimary && (
                <Button
                    className={styles.button}
                    onClick={buttonPrimary.onClick}
                    data-name="request-payment"
                    theme="vk"
                    primary
                    fluid={isPhone}
                    sizeMode={isPhone ? ButtonSizeMode.big : ButtonSizeMode.small}
                >
                    {buttonPrimary.text}
                </Button>
            )}
            {buttonSecondary && (
                <Button
                    className={styles.button}
                    onClick={buttonSecondary.onClick}
                    theme="vk"
                    data-name="skip"
                    fluid={isPhone}
                    sizeMode={isPhone ? ButtonSizeMode.big : ButtonSizeMode.small}
                >
                    {buttonSecondary.text}
                </Button>
            )}
        </div>
    );
};
